import {
    BadgeCheck,
    Globe2,
    RefreshCcw,
    ShieldCheck,
    Truck,
} from "lucide-react";
import "./LandingBenefits.css";

type Benefit = {
    title: string;
    description: string;
    icon: React.ReactNode;
};

const benefits: Benefit[] = [
    {
        title: "100% Refund, Return & Exchange",
        description: "Simple and customer-friendly returns",
        icon: <RefreshCcw size={21} strokeWidth={1.8} />,
    },
    {
        title: "Premium Beyond Limits",
        description: "Quality products from trusted sellers",
        icon: <BadgeCheck size={21} strokeWidth={1.8} />,
    },
    {
        title: "Shipping Across the Globe",
        description: "Reliable delivery wherever you shop",
        icon: <Globe2 size={21} strokeWidth={1.8} />,
    },
    {
        title: "End-to-End Secure Payments",
        description: "Protected payments from start to finish",
        icon: <ShieldCheck size={21} strokeWidth={1.8} />,
    },
    {
        title: "Faster Than Expected",
        description: "Quick and dependable order delivery",
        icon: <Truck size={21} strokeWidth={1.8} />,
    },
];

const LandingBenefits = () => {
    return (
        <section className="landing-benefits">
            <div className="landing-benefits-grid">
                {benefits.map((benefit) => (
                    <div className="landing-benefit-item" key={benefit.title}>
                        <span className="landing-benefit-icon">
                            {benefit.icon}
                        </span>
                        <div className="landing-benefit-content">
                            <strong>{benefit.title}</strong>
                            <span>{benefit.description}</span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default LandingBenefits;